import type {PickerVariable} from "../model/types";
import {variableAttributes, variableTokenPattern} from "../model/variableToken";

const escapeAttribute = (value: string) => value
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

/**
 * Stored text with its known tokens turned into the node's HTML, for a host that loads text into the
 * editor (markdown, a plain string) rather than document JSON.
 *
 * Pass the same variables the editor's catalogue holds: the node's HTML parsing drops a span whose
 * key the catalogue does not know, and its token would be gone on the next save. A token this skips
 * stays the text it was, so nothing an author wrote disappears.
 */
export const variableTokensToHtml = (text: string, variables: readonly PickerVariable[]): string =>
    text.replace(variableTokenPattern(), token => {
        const attributes = variableAttributes(variables, token);
        if (!attributes) return token;

        const format = attributes.format ? ` data-format="${escapeAttribute(attributes.format)}"` : "";

        return `<span data-variable="${escapeAttribute(attributes.key)}"`
            + ` data-fallback="${escapeAttribute(attributes.fallback)}"${format}></span>`;
    });

export default variableTokensToHtml;
